// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1626439241554
      var cssReload = require("E:/3x1010/Projects-2021/dev.mazehero.3x1010.it/VisualStudio/Web/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  